export default __webpack_public_path__ + "static/media/HVACSystemsImg.7d0e96a0.jpg";